export default __webpack_public_path__ + "5262fd4a9c694416307bb8b4ec48c18b.jpg";